import { Flex, Text } from "@chakra-ui/layout";
import { PieChart, Pie, Cell } from "recharts";
import colors from "core/resources/theme/colors";
import { Skeleton } from "@chakra-ui/skeleton";
import { formatMoney } from "infra/helpers/number";

interface GraficoAcordoProps {
  somaParcelas?: number;
  restamParcelas?: number;
  loading?: boolean;
}

export default function GraficoAcordo({
  restamParcelas,
  somaParcelas,
  loading,
}: GraficoAcordoProps) {
  const size = 200;
  return (
    <Flex flexDir="column" gap={6}>
      {!loading ? (
        <PieChart
          style={{
            background: colors.blue100,
            margin: "auto",
            borderRadius: "50%",
          }}
          width={size}
          height={size}
        >
          <Pie
            isAnimationActive={false}
            dataKey="value"
            data={[
              { name: "Soma", value: somaParcelas },
              { name: "Restam", value: restamParcelas },
            ]}
            innerRadius={40}
            outerRadius={size / 2.4}
            labelLine={false}
            label={(props) => renderCustomizedLabel(props)}
          >
            <Cell
              key={`cell-0`}
              fill={colors.blue}
              display={somaParcelas ? undefined : "none"}
            />

            <Cell
              key={`cell-1`}
              fill={colors.gray}
              display={restamParcelas ? undefined : "none"}
            />
          </Pie>
        </PieChart>
      ) : (
        <Skeleton w="90px" h="90px" rounded="full" />
      )}

      <Flex gap={6} margin="auto">
        <Flex gap={2}>
          <Flex
            borderTopRadius="10px"
            borderBottomRadius="10px"
            bg={colors.blue}
            w="5px"
            h="40px"
          />
          {!loading ? (
            <Flex flexDir="column">
              <Text fontSize="13px">Soma</Text>
              <Text fontSize="16px" fontWeight="bold">
                {formatMoney(somaParcelas)}
              </Text>
            </Flex>
          ) : null}
          {loading ? <Skeleton w="80px" h="20px" rounded="full" /> : null}
        </Flex>

        <Flex gap={2}>
          <Flex
            borderTopRadius="10px"
            borderBottomRadius="10px"
            bg={colors.gray}
            w="5px"
            h="40px"
          />
          {!loading ? (
            <Flex flexDir="column">
              <Text fontSize="13px">Restam</Text>
              <Text fontSize="16px" fontWeight="bold">
                {formatMoney(restamParcelas)}
              </Text>
            </Flex>
          ) : null}
          {loading ? <Skeleton w="80px" h="20px" rounded="full" /> : null}
        </Flex>
      </Flex>
    </Flex>
  );
}

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  value,
}: any) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  if (!percent) {
    return null;
  }

  return (
    <g>
      <circle
        x={x}
        y={y}
        cx={x}
        cy={y}
        r={30}
        stroke="#ffffff"
        fill="#ffffff"
      />
      <text
        x={x}
        y={y}
        fontWeight="500"
        fill="black"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="14px"
      >
        {formatMoney(value)}
      </text>
    </g>
  );
};
